import React, { useState, useEffect } from "react";
import { CircularProgress, withStyles } from "@material-ui/core";
import { findValoresByConvenioAndProcedimentos } from "../../services/ProcedimentoService";
import { applyCurrencyMask } from "../../utils/CurrencyMask";
import { observer } from "mobx-react-lite";
import { findValorByConvenioAndAgendamentoTipo } from "../../services/AgendamentoTipoService";

const AtendimentoModalTabFinanceiro = observer(({ classes, objView }) => {
  const [procedimentos, setProcedimentos] = useState([]);
  const [agendamentoTipo, setAgendamentoTipo] = useState(null);
  const [loading, setLoading] = useState(true);

  const convenioId = objView?.convenio?.id || objView?.convenio?.value;
  const agendamentoTipoId = objView?.tipo?.value || objView?.tipo?.id;
  const procedimentoIds = objView?.procedimentos
    ?.map((item) => item.procedimento?.id)
    .filter(Boolean);

  useEffect(() => {
    loadFinanceiro();
  }, [objView?.id, convenioId, agendamentoTipoId, procedimentoIds?.length]);

  const loadFinanceiro = async () => {
    try {
      setLoading(true);

      const [procedimentosResponse, tipoResponse] = await Promise.all([
        convenioId && procedimentoIds?.length > 0
          ? findValoresByConvenioAndProcedimentos({
              convenioId,
              procedimentoIds,
            })
          : Promise.resolve([]),
        convenioId && agendamentoTipoId
          ? findValorByConvenioAndAgendamentoTipo({
              convenioId,
              agendamentoTipoId,
            })
          : Promise.resolve(null),
      ]);

      setProcedimentos(procedimentosResponse || []);
      setAgendamentoTipo(tipoResponse);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className={classes.wrapperLoading}>
        <CircularProgress />
      </div>
    );
  }

  if (!procedimentos.length && !agendamentoTipo) {
    return (
      <div className={classes.mensagemVazia}>
        Nenhum dado financeiro encontrado.
      </div>
    );
  }

  const valorTipo = agendamentoTipo?.valor || 0;
  const valorTotalProcedimentos = procedimentos.reduce(
    (acc, item) => acc + (item.valorVigente?.valor || item.valor || 0),
    0,
  );
  const valorTotal = valorTipo + valorTotalProcedimentos;

  return (
    <div className={classes.content}>
      {agendamentoTipo && (
        <div className={classes.section}>
          <div className={classes.sectionTitle}>Tipo de Atendimento</div>
          <div className={classes.item}>
            <span className={classes.itemNome}>
              {agendamentoTipo.agendamentoTipo?.descricao}
            </span>
            <span className={classes.itemValor}>
              {applyCurrencyMask(valorTipo)}
            </span>
          </div>
        </div>
      )}

      {procedimentos.length > 0 && (
        <div className={classes.section}>
          <div className={classes.sectionTitle}>Procedimentos</div>
          {procedimentos.map((item, index) => (
            <div key={index} className={classes.item}>
              <span className={classes.itemNome}>
                {item.procedimento?.nome || item.procedimento?.descricao}
              </span>
              <span className={classes.itemValor}>
                {applyCurrencyMask(item.valorVigente?.valor || item.valor || 0)}
              </span>
            </div>
          ))}
        </div>
      )}

      <div className={classes.totalContainer}>
        <span className={classes.totalLabel}>Valor Total</span>
        <span className={classes.totalValor}>
          {applyCurrencyMask(valorTotal)}
        </span>
      </div>
    </div>
  );
});

const styles = {
  content: {
    display: "flex",
    flexDirection: "column",
    height: "calc(100% - 40px)",
    overflowY: "auto",
    gap: "12px",
  },
  section: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  sectionTitle: {
    fontSize: "12px",
    fontWeight: "700",
    color: "#505050",
    paddingBottom: "4px",
    borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
  },
  item: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "6px 0",
    gap: "4px",
  },
  itemNome: {
    fontSize: "12px",
    fontWeight: "500",
    color: "#505050",
    width: "100%",
  },
  itemValor: {
    fontSize: "12px",
    fontWeight: "600",
    color: "#505050",
  },
  totalContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 0",
    borderTop: "2px solid #505050",
    marginTop: "4px",
  },
  totalLabel: {
    fontSize: "14px",
    fontWeight: "700",
    color: "#333",
  },
  totalValor: {
    fontSize: "14px",
    fontWeight: "700",
    color: "#219A97",
  },
  mensagemVazia: {
    display: "flex",
    justifyContent: "center",
    padding: "20px",
    fontSize: "14px",
    color: "#868686",
  },
  wrapperLoading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: 100,
  },
};

export default withStyles(styles)(AtendimentoModalTabFinanceiro);
